module.exports = __webpack_public_path__ + "static/img/produto_p.baa402e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/oitosegundos/produto_p.png
// module id = wMe5
// module chunks = 0